export const routes = [
  {
    path: 'incidentes',
    name: 'operational_incidents',
    component: () => import('./Index.vue'),
    meta: { permissions: ['administrator'] },
  },
];
